import script from "./AvatarPortrait.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarPortrait.vue?vue&type=script&setup=true&lang=js"

import "./AvatarPortrait.vue?vue&type=style&index=0&id=32a3c423&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a3c423"]])

export default __exports__